export default __webpack_public_path__ + "fonts/CiscoSansLightOblique-webfont.eot";